import { DATE_TIME_FORMAT } from 'config/constants';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export function formatDate(
  dateValue: Date | null,
  formattype: string,
  locale?: string
): null | string {
  if (!dateValue) return null;

  dayjs.locale(locale || 'en');
  return dayjs(dateValue).format(formattype);
}

export function formatDateTime(localTimeHour: string) {
  return dayjs(localTimeHour).format(DATE_TIME_FORMAT);
}
